export default __webpack_public_path__ + "static/media/5.df26de62.jpg";